import Accordions from '../../components/accordions/Accordions'
import Footer from '../../components/footer/Footer'
import Help from '../../components/help/Help'
import Hero from '../../components/hero/Hero'
import Houses from '../../components/houses/Houses'
import ListingDirective from '../../components/listdirectives/ListingDirective'
import Navbar from '../../components/navbar/Navbar'
import Properties from '../../components/properties/Properties'
import Responsibility from '../../components/responsibility/Responsibility'
import Testimonial from '../../components/textimonial/Testimonial'
import Visit from '../../components/visit/Visit'
import './home.css'

function Home() {
    return (
        <div className='home'>
          <Navbar/> 
          <Hero/>
          <Houses/>
          <Properties/>
          <Accordions/>
          <ListingDirective/>
          <Responsibility/>
          <Testimonial/>
          <Help/>
          <Visit/>
          <Footer/>
        </div>
    )
}

export default Home
